import axios from 'axios'
import { Notification, Message } from 'element-plus'
import qs from 'qs'
import Config from '@/settings'

const service = axios.create({
    // withCredentials: true,
    crossDomain: true,
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API, // api 的 base_url
    timeout: Config.timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        // 判断是否是文件上传请求
        if (config.method === 'post') {
            // 普通 POST 请求处理数据
            config.data = qs.stringify({
                ...config.data
            });
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        return config
    },
    error => {
        // Do something with request error
        Promise.reject(error)
    }
)
// response 拦截器
service.interceptors.response.use(
    response => {
        const code = response.data.code;
        // 处理其他错误
        if (code !== 200) {
            Message.error({
                message: response.data.msg
            });
            return Promise.reject(response.data.msg);
        }
        return response.data;
    },
    error => {
        // 统一处理请求失败的情况
        Notification.error({
            title: '请求失败',
            message: error.message || '网络错误',
            duration: 5000
        });
        return Promise.reject(error);
    }
);

export default service
